/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when an Entity could not be updated
 * @export
 * @class EntityCouldNotUpdateEntityError
 * @extends {Error}
 */
export class EntityCouldNotUpdateEntityError extends Error {
  /**
   * Creates an instance of EntityCouldNotUpdateEntityError
   * @param {string} message The Error `message`
   * @memberof EntityCouldNotUpdateEntityError
   */
  constructor(message) {
    super(message);
    this.name = `EntityCouldNotUpdateEntityError`;
  }
}

/**
 * Called when an Entity could not be updated
 * @param {sting} id The `id` of the entity to update
 * @returns {never} never
 */
const throwEntityCouldNotUpdateEntityError = (id) => {
  throw new EntityCouldNotUpdateEntityError(
    stripIndent(`
    Can not update entity: "${id}".
    Entity does not exist.
    Did you mean add?
    `),
  );
};

export default throwEntityCouldNotUpdateEntityError;
